import { SET_SCROLL_TO_TOP } from '../types'

export default (state, action) => {
  switch (action.type) {
    case SET_SCROLL_TO_TOP:
      return {
        ...state,
        scrollToTop: action.payload,
      }
    default:
      return state
  }
}
